import {loadJoinTeamData} from '@/services/join';
import splitter from 'full-name-splitter';

export default {
  state: {
    joinInfo: {
      loaded: false,
      teamName: null
    },
  },
  mutations: {
    setJoinState(state, obj) {
      Object.assign(state.joinInfo, obj);
    }
  },
  actions: {
    async loadJoinTeamData({commit}, {team, token}) {
      // Load team data, so we can validate whether
      // it is valid and show the name.
      try {
        let teamData = await loadJoinTeamData(team, token);
        commit('setJoinState', {
          loaded: true,
          teamName: teamData.name
        });
      } catch(e) {
        // TODO set error state
      }
    }
  },
  getters: {
    joinTeamName: state => state.joinInfo.teamName,
    joinTeamUrl: (state, getters) => {
      let team = getters.team;
      return team && `${URLS.APP}/join/${team.id}/${team.join_token}`;
    },
    joinTeamLoaded: state => state.joinInfo.loaded,
  }
}



// WEBPACK FOOTER //
// ./src/store/join.js